<template>

	<!-- <section class="col-xs-12 npd novedades"> -->
			<!-- <h2>NOVEDADES</h2> -->

			<section class="col-xs-12 npd novedades__bloque">
				<div class="container">
					<div class="row">

						<div class="col-xs-12 npd novedades__categoria">
							<div class="col-xs-12 col-md-6">
								<h3>
										<i class="icon" v-if="cat_icon" v-bind:style="'background-image: url('+cat_icon+')'">
										</i>

										{{ categoria }}
								</h3>
							</div>
							<div class="col-xs-12 col-md-6 text-right">
								<router-link :to="{ name: 'cat', params: { name:slug } }">
									Ver todo >
								</router-link>
							</div>
						</div>
						<div class="col-xs 12">

							<div class="col-xs-6 col-md-3" v-for="noticia in noticias">
								<!-- <a v-bind:href="noticia.link"> -->
								<router-link :to="{ name: 'post', params: { name:noticia.slug }}">

									<figure v-if="noticia.better_featured_image !== null">
										<img v-bind:src="noticia.better_featured_image.media_details.sizes['536x516'].source_url" alt="">
									</figure>
									<figure v-else-if="noticia.featured_image_src['full'][0]">
										<img v-bind:src="noticia.featured_image_src['full'][0]" alt="">
									</figure>
									<figure v-else>
										<img v-bind:src="theme_url+'/html/assets/img/novedad.jpg'" alt="">
									</figure>

									<h3 v-html="noticia.title.rendered"></h3>
								<!-- </a> -->
								</router-link>
							</div>


						</div>
					</div>
				</div>
			</section>

</template>



<script>
export default {

	props:[
		'post_id',
	],
	mounted: function() {
		const vm = this;
		vm.getNoticias();
	},

	data() {
		return {
			base_path: rtwp.base_path,
			pageTitle: rtwp.site_name,
			theme_url:rtwp.theme_url,
			categoria:'',
			slug:'',
			cat_icon:false,
			cat_id:0,
			noticias:[],
		};
	},
	methods: {
		getNoticias: function() {
			const vm = this;
			vm.$http.get( 'wp/v2/posts/?categories='+vm.post_id.acf.categoria+'&per_page=4')
			.then( ( res ) => {
				vm.noticias = res.data;
				vm.loaded = 'true';
				res.data[0].cat_name.forEach(function(elem){
					if(elem.id==vm.post_id.acf.categoria){
						vm.categoria = elem.name;
						vm.slug = elem.slug;
						vm.cat_id = elem.id;
						vm.cat_icon = res.data[0].categoria_meta[elem.id].meta.icono.sizes['24x24'];
						vm.cat_icon = vm.post_id.better_featured_image.source_url;
					}
				});
				vm.$nextTick(function(){
					init_attach();
				});
			} )
			.catch( ( res ) => {
				//console.log( `Something went wrong : ${res}` );
			} );
		}
	}
};
</script>



// WEBPACK FOOTER //
// categoriaportada.vue?2822f9c9